export default __webpack_public_path__ + "img/2aef1efef1b18caf093351184b54a78d.jpg";